export default "__VITE_ASSET__D20zVj$8__"